import _ from 'lodash';
import React, { useState } from 'react';
import ArrayBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/ArrayBuilder';
import { Icon, SelectMenu } from '@scale/scaleui';
import { WorkerThresholdTypeSchemaMap } from '@scale/shared/pipelinev3/genai';
import {
  ArrayValueComparator,
  WorkerBasedRoutingOverrideThresholdType,
  WorkerBasedRoutingOverrideThreshold,
} from '@scale/shared-types';
import type { TypeBuilderMapType } from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderSchemasType';

interface WorkerBasedRoutingOverrideThresholdBuilderProps {
  name: string;
  existingValue?: Array<WorkerBasedRoutingOverrideThreshold>;
  updateProperty: (arg: Array<WorkerBasedRoutingOverrideThreshold> | undefined) => void;
  required?: boolean;
  typeBuilderMap: TypeBuilderMapType;
}

const thresholdTypeOptions: Array<{ id: WorkerBasedRoutingOverrideThresholdType; name: string }> = [
  {
    id: WorkerBasedRoutingOverrideThresholdType.WorkerTags,
    name: 'Worker Tags',
  },
];

const DEFAULT_THRESHOLD_CONFIGS: Record<WorkerBasedRoutingOverrideThresholdType, any> = {
  [WorkerBasedRoutingOverrideThresholdType.WorkerTags]: {
    type: WorkerBasedRoutingOverrideThresholdType.WorkerTags,
    comparator: ArrayValueComparator.ContainsAny,
    tags: [],
  },
};

const WorkerBasedRoutingOverrideThresholdBuilder: React.FC<
  WorkerBasedRoutingOverrideThresholdBuilderProps
> = ({ name, existingValue = [], updateProperty, typeBuilderMap }) => {
  const variables = existingValue;
  const [selectedType, setSelectedType] = useState<WorkerBasedRoutingOverrideThresholdType>(
    WorkerBasedRoutingOverrideThresholdType.WorkerTags,
  );

  const addThreshold = (type: WorkerBasedRoutingOverrideThresholdType) => {
    const newThresholds = _.clone(variables);
    newThresholds.push(_.cloneDeep(DEFAULT_THRESHOLD_CONFIGS[type]));
    updateProperty(newThresholds);
  };

  return (
    <div className="scaleui scaleui-tailwind scale-theme">
      {name && <div className="my-2 text-sm font-medium leading-6 text-neutral-700">{name}</div>}
      <ArrayBuilder
        typeBuilderMap={typeBuilderMap}
        elements={variables}
        setElements={updateProperty}
        getKey={variable => JSON.stringify(variable)}
        getTitle={variable => `${variable.type}`}
        getSchema={config => WorkerThresholdTypeSchemaMap[config.type]}
      />
      <div className="flex">
        <SelectMenu
          className="min-w-[135px]"
          options={thresholdTypeOptions}
          selectedOptionId={selectedType}
          setSelected={value => {
            setSelectedType(value);
          }}
        />
        <Icon
          className="ml-4"
          hasBackground
          icon={['fas', 'plus']}
          onClick={() => addThreshold(selectedType)}
          size="lg"
          variant="primary"
        />
      </div>
    </div>
  );
};

export default WorkerBasedRoutingOverrideThresholdBuilder;
